import { render, staticRenderFns } from "./FabricStatusPicker.vue?vue&type=template&id=a5e0f828&scoped=true&"
import script from "./FabricStatusPicker.vue?vue&type=script&lang=ts&"
export * from "./FabricStatusPicker.vue?vue&type=script&lang=ts&"
import style0 from "./FabricStatusPicker.vue?vue&type=style&index=0&id=a5e0f828&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e0f828",
  null
  
)

export default component.exports